import React, { useState, useEffect, useMemo, useRef } from "react";
import { FilterBar } from "../../BOOKLET_MODUL/Components/Report/ReportFilter";
import { PrintTable } from "../..//BOOKLET_MODUL/Components/Report/PrintDetail_Table";
import { BookletDrawer } from "../..//BOOKLET_MODUL/Components/Report/BookletDetails_drawer";
import {
  FilterState,
  PrintRecord,
  PrintStatus,
  User,
  UserRole,
} from "../../BOOKLET_MODUL/Components/Report/IReport";
import { useAppSelector } from "../../../Redux/Store/Hooks";
import { useDispatch } from "react-redux";
import { ReportList } from "../../../Redux/Slices/Booklet/Admin/Report/ReportList";
import { ReportFilter } from "../../../Redux/Slices/Booklet/Admin/Report/ReportFilter";
import { Box } from "@mui/material";
import { centreMasterRead } from "../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMatserRead";
import { decode } from "../../../Utils/encodeDecode";
import { TutorReportList } from "../../../Redux/Slices/Booklet/Tutor/Report/TutorReportList";
import { TutorReportFilter } from "../../../Redux/Slices/Booklet/Tutor/Report/TutorReportFilter";
import ExcelDownloader from "./ReportDownloader";

const Histroy: React.FC = () => {
  const dispatch = useDispatch();
  const excelDownloaderRef = useRef<any>(null);
  const [filters, setFilters] = useState<FilterState>({
    centreId: "",
    dayOfWeek: "",
    classId: "",
    searchQuery: "",
  });

  const { data: AdminReportData, isLoading: ReportLoading } = useAppSelector(
    (state) => state.TutorAdminReportList
  );

  const { data: AdminFilterData, isLoading: FilterLoading } = useAppSelector(
    (state) => state.TutorAdminReportFilter
  );

  const { data: TutorReportData, isLoading: TutorReportLoading } =
    useAppSelector((state) => state.TutorReportList);

  const { data: TutorFilterData, isLoading: TutorFilterLoading } =
    useAppSelector((state) => state.TutorReportFilter);

  const { data: listCentersData, isLoading: centerLoading } = useAppSelector(
    (state) => state.CentreMasterReadSlice
  );

  const [selectedRecord, setSelectedRecord] = useState<PrintRecord | null>(
    null
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState<any>({});

  const ReportData = AdminReportData || TutorReportData;
  const FilterData = AdminFilterData || TutorFilterData;

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setUser(userDetails);
  }, []);

  const isAdminRole =
    user.role === "ADMIN" ||
    user.role === "TUTOR_ADMIN" ||
    user.role === "CRM_ADMIN";

  const isTutorRole = user.role === "TUTOR";

  useEffect(() => {
    if (!user?.role) return; // wait until user exists

    if (isAdminRole) {
      dispatch(ReportList({}));
      dispatch(ReportFilter({}));
    }

    if (isTutorRole) {
      dispatch(TutorReportList({}));
      dispatch(TutorReportFilter({}));
    }

    dispatch(centreMasterRead());
  }, [user]);

  useEffect(() => {
    if (!filters.centreId && !filters.dayOfWeek && !filters.classId) return;

    const payload: any = {};
    if (filters.centreId) {
      payload.center_id = filters.centreId;
    }
    if (filters.dayOfWeek) {
      payload.day = filters.dayOfWeek;
    }
    if (filters.classId) {
      payload.class_csms_id = filters.classId;
    }
    if (isAdminRole) {
      dispatch(ReportList(payload));
    }
    if (isTutorRole) {
      dispatch(TutorReportList(payload));
    }
  }, [filters.centreId, filters.dayOfWeek, filters.classId, dispatch]);

  useEffect(() => {
    if (!filters.centreId && !filters.dayOfWeek) return;

    const payload: any = {};
    if (filters.centreId) {
      payload.center_id = filters.centreId;
    }
    if (filters.dayOfWeek) {
      payload.day = filters.dayOfWeek;
    }
    if (isAdminRole) {
      dispatch(ReportFilter(payload));
    }
    if (isTutorRole) {
      dispatch(TutorReportFilter(payload));
    }
  }, [filters.centreId, filters.dayOfWeek, dispatch]);

  console.log(FilterData, "FilterData");

  const DAYS_OF_WEEK = [
    { label: "Monday", value: "MONDAY" },
    { label: "Tuesday", value: "TUESDAY" },
    { label: "Wednesday", value: "WEDNESDAY" },
    { label: "Thursday", value: "THURSDAY" },
    { label: "Friday", value: "FRIDAY" },
    { label: "Saturday", value: "SATURDAY" },
    { label: "Sunday", value: "SUNDAY" },
  ];

  const availableCentres = useMemo(() => {
    if (!listCentersData?.data) return [];

    return listCentersData.data.map((c: any) => ({
      id: c.center_id,
      name: c.center_name,
    }));
  }, [listCentersData]);

  const classOptions = useMemo(() => {
    if (!FilterData?.data?.classes) return [];
    return FilterData.data.classes.map((c: any) => ({
      id: c.csms_id, // unique ID
      name: c.display, // display text
    }));
  }, [FilterData]);

  const mergeStatuses = (approval?: string, printing?: string): PrintStatus => {
    // Approval → Combined Status
    if (approval === "pending") return PrintStatus.REQUESTED;
    if (approval === "approved") return PrintStatus.APPROVED;
    if (approval === "rejected") return PrintStatus.REJECTED;

    // Printing → Combined Status
    if (printing === "not_yet_started") return PrintStatus.NOT_YET_STARTED;
    if (printing === "in_progress") return PrintStatus.IN_PROGRESS;
    if (printing === "completed") return PrintStatus.COMPLETED;
    if (printing === "failed") return PrintStatus.FAILED;

    // fallback
    return PrintStatus.REQUESTED;
  };

  const mapApiToPrintRecords = (items: any[]): PrintRecord[] => {
    return items.map((item: any) => ({
      id: item.cart_id,
      datePrinted: item.date_created,
      centreId: item.class_details?.center_id ?? "",
      centreName: item.centre ?? "",
      dayOfWeek: item.class_details?.day ?? "",
      classId: item.class_details?.csms_id ?? "",
      className:
        (item.class_details?.subject_name || item.class_details?.name) ?? "",
      tutorName: item.tutor_name ?? "",
      subject: item.booklet?.subject ?? "",
      topic: item.topic ?? "",
      bookletId: item.booklet?.file_id ?? "",
      bookletName: item.booklet?.name ?? "",
      bookletDrivePath: item.booklet?.parent_id ?? "",
      bookletDriveUrl: item.booklet?.web_view_link ?? "",
      printCount: item.count ?? 0,
      requestedBy: item.tutor_name ?? "",
      requestedDate: item.date_created ?? "",
      status: mergeStatuses(
        item.status?.approval_status?.toLowerCase(),
        item.status?.printing_status?.toLowerCase()
      ),

      // status: {
      //   approvalStatus: item.status?.approval_status ?? "pending",
      //   printingStatus: item.status?.printing_status ?? "not_yet_started",
      // },
    }));
  };

  const printRecords: PrintRecord[] = useMemo(() => {
    if (!ReportData?.data) return [];
    return mapApiToPrintRecords(ReportData.data);
  }, [ReportData]);

  const filteredData = useMemo(() => {
    return printRecords.filter((record: PrintRecord) => {
      const matchCentre =
        !filters.centreId ||
        String(record.centreId) === String(filters.centreId);

      const matchDay =
        !filters.dayOfWeek ||
        record.dayOfWeek?.toLowerCase() === filters.dayOfWeek.toLowerCase();

      const matchClass =
        !filters.classId || String(record.classId) === String(filters.classId);

      const searchLower = filters.searchQuery.toLowerCase();
      const matchSearch =
        !filters.searchQuery ||
        record.tutorName.toLowerCase().includes(searchLower) ||
        record.bookletName.toLowerCase().includes(searchLower) ||
        record.subject.toLowerCase().includes(searchLower) ||
        record.topic.toLowerCase().includes(searchLower);

      return matchCentre && matchDay && matchClass && matchSearch;
    });
  }, [filters, user, printRecords]);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 400);
    return () => clearTimeout(timer);
  }, [filters, user]);

  const handleFilterChange = (key: keyof FilterState, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleClearFilters = () => {
    setFilters({
      centreId: "",
      dayOfWeek: "",
      classId: "",
      searchQuery: "",
    });
  };

  const handleRowClick = (record: PrintRecord) => {
    setSelectedRecord(record);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setTimeout(() => setSelectedRecord(null), 300);
  };

  const handleExcelDownload = () => {
    if (filteredData.length === 0) {
      alert("No data to export!");
      return;
    }

    // Trigger the child's export function via ref
    excelDownloaderRef.current?.exportExcel();
  };
  // // Demo helper
  // const toggleUser = () => {
  //   setUser(prev => prev.role === UserRole.ADMIN ? MOCK_USER_TUTOR : MOCK_USER_ADMIN);
  //   handleClearFilters(); // Reset filters when role changes to avoid confusing states
  // };

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <FilterBar
        filters={filters}
        onFilterChange={handleFilterChange}
        centres={availableCentres}
        days={DAYS_OF_WEEK}
        classes={classOptions}
        onClear={handleClearFilters}
        onExcelDownload={() => handleExcelDownload()}
      />
      {/* Hidden ExcelDownloader — only used to trigger download */}
      <ExcelDownloader
        ref={excelDownloaderRef}
        data={filteredData}
        fileName="Print_History.xlsx"
        currentUser={user}
      />

      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
          bgcolor: "#f2f2f2",
          p: 2,
        }}
      >
        <PrintTable
          data={filteredData}
          isLoading={isLoading}
          onRowClick={handleRowClick}
          currentUser={user}
        />
      </Box>

      <BookletDrawer
        isOpen={isDrawerOpen}
        onClose={closeDrawer}
        record={selectedRecord}
      />
    </Box>
  );
};

export default Histroy;
